import initApi from "@/api/app/init/init";
import dayjs from "dayjs";

import { store } from "@/web/components/state/store";
import { GetUserInfo } from "@/employee/components/state/actions/login";

let timeOffset = null;

const init = async () => {
  let data = await initApi.getData();
  let sTime = dayjs(data)._d;
  let nTime = new Date();
  timeOffset = sTime.getTime() - nTime.getTime();
};

const nowTime = () => {
  let user = GetUserInfo() //store.getState().userInfStateReducer;
  let siteIdCurrent = user && user.userInfo && user.userInfo.siteIdCurrent ? user.userInfo.siteIdCurrent : null
  let timeZone = siteIdCurrent && siteIdCurrent.timeZone ? siteIdCurrent.timeZone : "";

  // let timeZone = -6; // Timezone offset in hours (e.g., CST)
  let nTime = new Date();
  let utcTime = nTime.getTime() + nTime.getTimezoneOffset() * 60000; // Convert local time to UTC
  let sTime = new Date(utcTime + timeZone * 3600000); // Apply timezone offset
  return sTime;

  // let timeZone = -6
  // let nTime = new Date();
  // let sTime = new Date(nTime.getTime() + timeOffset);
  // return sTime;
};
//"Thu May 11 2023 00:00:00 GMT+0800 (China Standard Time)" converted to "2023-05-11"
const formatData = (data) => {
  let timeZone = -6; 
  const date = new Date(data);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
};
export default {
  init,
  nowTime,
  formatData
};
